// src/components/Footer/Footer.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchFooter } from "./FooterQuery";
import "./Footer.css";

const Footer = () => {
  const [footer, setFooter] = useState(null);

  useEffect(() => {
    async function loadFooter() {
     const data = await fetchFooter();
     console.log("footer data:",data);

      const footerData = data?.footer?.[0];
      if (!footerData || !footerData.enabled) {
        setFooter(null);
        return;
      }
      setFooter(footerData);
    }
    loadFooter();
  }, []);

  if (!footer) return null; // no layout break

  const {
    openinghoursTitle,
    openDays,
    openTimes,
    linkComponent,
    contactusTitle,
    address,
    infoSectionComponent,
    socialIconComponent,
    linkTitle,
    copyRightText,
    privacypolicyUrl,
    termsofuseUrl,
  } = footer;

  const BASE_URL = process.env.REACT_APP_CMS_BASE_URL;

  const getFullUrl = (url) =>
    url?.startsWith("http") ? url : `${BASE_URL}${url}`;

  const links =
    linkComponent?.contentItems?.filter((item) => item.enabled && item.url) ||
    [];

  const infoSections =
    infoSectionComponent?.contentItems?.filter((item) => item.enabled) || [];

  const socialIcons =
    socialIconComponent?.contentItems?.filter((item) => item.enabled) || [];

  return (
    <footer className="footer">
      <div className="footer-top">
        {/* Opening Hours */}
        <div className="footer-col">
          <h3>{openinghoursTitle}</h3>
          <p>{openDays}</p>
          <p>{openTimes}</p>
        </div>

        {/* Links */}
        <div className="footer-col">
          <h3>{linkTitle}</h3>
          {links.map((linkObj, index) => (
            <Link key={index} to={linkObj.url.url}>
              {linkObj.url.text}
            </Link>
          ))}
        </div>

        {/* Contact + Info + Social */}
        <div className="footer-col">
          <h3>{contactusTitle}</h3>
          <p>{address}</p>

          <div className="info-section">
            {infoSections.map((info, idx) => (
              <div key={idx} className="info-item">
                {info.image?.urls?.[0] && (
                  <img
                    src={getFullUrl(info.image.urls[0])}
                    alt="Info"
                    className="info-img"
                  />
                )}
                <p>{info.text}</p>
              </div>
            ))}
          </div>

          <div className="social-icons">
            {socialIcons.map((icon, index) => (
              <div className="social-icon-wrapper" key={index}>
                <a
                  href={icon.link?.url || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={getFullUrl(icon.image?.urls?.[0])}
                    alt={icon.link?.text || "social"}
                  />
                  <span className="icon-tooltip">{icon.link?.text}</span>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Row */}
      <div className="footer-bottom">
        <p>{copyRightText}</p>

        <div className="footer-links">
          {privacypolicyUrl && (
            <Link to="/html?tab=privacy">{privacypolicyUrl.text}</Link>
          )}
          {termsofuseUrl && (
            <Link to="/html?tab=tou">{termsofuseUrl.text}</Link>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
